module.exports = __webpack_public_path__ + "static/img/Flat_MacBook_2.aba51a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Flat_MacBook_2.png
// module id = H6C/
// module chunks = 1